import type { PDFDocumentProxy } from 'pdfjs-dist'

export const MAX_MARKUP_PDF_PAGES = 10

type PdfjsLib = typeof import('pdfjs-dist') // eslint-disable-line @typescript-eslint/consistent-type-imports

let pdfjsPromise: Promise<PdfjsLib> | null = null

const loadPdfJs = (): Promise<PdfjsLib> => {
  if (!pdfjsPromise) {
    pdfjsPromise = import('pdfjs-dist').then((pdfjsLib) => {
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        '//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.worker.min.mjs'
      return pdfjsLib
    })
  }
  return pdfjsPromise
}

export const getPdfPageCount = async (pdfUrl: string): Promise<number> => {
  const pdfjsLib = await loadPdfJs()
  const pdf: PDFDocumentProxy = await pdfjsLib.getDocument(pdfUrl).promise
  const numPages = pdf.numPages
  pdf.destroy()
  return numPages
}

export const getPdfDocument = async (pdfUrl: string): Promise<PDFDocumentProxy> => {
  const pdfjsLib = await loadPdfJs()
  return pdfjsLib.getDocument(pdfUrl).promise
}
